module.exports = __webpack_public_path__ + "static/media/seguridad.5ad8f9c7.svg";